import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import { Paper } from '@mui/material';


export default function Pagenate(props: {
  currentPage: number
  totalPage: number
  onChagenPageEvent: (newPage: number) => void
}) {
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    props.onChagenPageEvent(newPage)
  };


  return (
    <React.Fragment>
      <Paper
        sx={{
          '& > *': {
            marginTop: 1,
            marginBottom: 1,
            display: 'inline-block',
          }
        }}
        style={{
          textAlign: 'center',
        }}>
        <Pagination
          size="large"
          onChange={handleChangePage}
          count={props.totalPage}
          page={props.currentPage}
          defaultPage={1}
          color="secondary"
        />
      </Paper>
    </React.Fragment >
  );
}